module.exports = __webpack_public_path__ + "static/media/34-transporttenester.a84ced33.mp3";